import { render, staticRenderFns } from "./cfdePhenotypeXing.vue?vue&type=template&id=5ef1428e&scoped=true"
import script from "./cfdePhenotypeXing.vue?vue&type=script&lang=js"
export * from "./cfdePhenotypeXing.vue?vue&type=script&lang=js"
import style0 from "./cfdePhenotypeXing.vue?vue&type=style&index=0&id=5ef1428e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef1428e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef1428e')) {
      api.createRecord('5ef1428e', component.options)
    } else {
      api.reload('5ef1428e', component.options)
    }
    module.hot.accept("./cfdePhenotypeXing.vue?vue&type=template&id=5ef1428e&scoped=true", function () {
      api.rerender('5ef1428e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdePhenotypeXing.vue"
export default component.exports